const accBtn = document.querySelectorAll('.about__innerBlockCntItemTtl');


window.onload = () => {
    accBtn.forEach((accBtnList) => {

        const cnt = accBtnList.nextElementSibling
        let height = cnt.clientHeight
        cnt.style.height = "0px"

        accBtnList.addEventListener('click', () => {
            const accBtnParent = accBtnList.parentNode;

            if (!accBtnParent.classList.contains('open')) {
                accBtnParent.classList.add('open');
                cnt.style.height = `${height}px`
            } else {
                accBtnParent.classList.remove('open');
                cnt.style.height = "0px"
            }
        });
    });
}